import { defineFilterSpec, enumField, multiField, text } from '@/lib/api/filter-spec';

import type { DiscountFilterFormValues, DiscountListFilters } from './types';

/** Single declaration of the discount list filters, shared by api/drawer/page. Multi-selects
 *  (format/applicability/status) join to a comma string on the wire under their own keys
 *  (`discountFormat`/`applicableTo`/`status` — no rename); created-date bounds pass through as
 *  strings (`createdFrom`/`createdTo`); `search` is query-only. */
const spec = defineFilterSpec<DiscountListFilters, DiscountFilterFormValues>([
  text('search'),
  multiField('discountFormat'),
  multiField('applicableTo'),
  multiField('status'),
  enumField('createdFrom'),
  enumField('createdTo'),
]);

export const toListQuery = spec.toListQuery;
export const toDefaults = spec.toDefaults;
export const toFilters = spec.toFilters;
export const hasActiveFilters = spec.hasActiveFilters;
